import { render, staticRenderFns } from "./deal-tabs.vue?vue&type=template&id=32b0b459&scoped=true&"
import script from "./deal-tabs.vue?vue&type=script&lang=ts&"
export * from "./deal-tabs.vue?vue&type=script&lang=ts&"
import style0 from "./deal-tabs.vue?vue&type=style&index=0&id=32b0b459&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b0b459",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32b0b459')) {
      api.createRecord('32b0b459', component.options)
    } else {
      api.reload('32b0b459', component.options)
    }
    module.hot.accept("./deal-tabs.vue?vue&type=template&id=32b0b459&scoped=true&", function () {
      api.rerender('32b0b459', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Deals/view/vue/deal-tabs.vue"
export default component.exports